import { Component, signal, viewChild, inject, effect } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from './shared/components/toast/toast';
import { ToastService } from './shared/services/toast.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('keylink-dashboard');
  private toastService = inject(ToastService);
  private toast = viewChild<Toast>('toast');

  constructor() {
    effect(() => {
      const toastConfig = this.toastService.toast();
      if (toastConfig) {
        this.toast()?.show(toastConfig);
      }
    });
  }
}
